import api from './base/updateModuleApi';

export default {
  updateModuleRefresh() {
    return api.post( 'api/modules/refreshCRM' );
  },
  updateModuleFinance( ) {
    return api.get( 'api/modules/informesfinancieros' );
  },
  updateModuleDoc( ) {
    return api.get( 'api/modules/documentacion' );
  },
  updateModulePhotos( ) {
    return api.get( 'api/modules/avancefotografico' );
  },
  updateModulePhotosKeys( ) {
    return api.get( 'api/modules/avancefotograficokeys' );
  },
  getLastCRMSyncStatus( ) {
    return api.get( 'api/modules/getLastSyncCRM' );
  },
};
